import React, { useMemo } from 'react';

import NodeTree from './node';
import Tree from 'react-d3-tree';

const DialogTreeComponent = ({ data = {} }) => {
  const formatToReactD3Tree = (info) => {
    const newData = {
      action: info?.action ?? {},
      name: info?.id,
      children:
        info?.nodes && Object.values(info?.nodes)?.length > 0
          ? Object.values(info?.nodes).map((item) => formatToReactD3Tree(item))
          : [],
      _collapsed: false,
      ...info,
      id: info?.id,
      original: { ...info }
    };

    return newData;
  };

  const formatedData = useMemo(() => formatToReactD3Tree(data[0]), [data]);

  return (
    <div id="treeWrapper" style={{ width: '100vw', height: '100vh' }}>
      <Tree
        data={formatedData}
        nodeSvgShape={{
          shape: 'rect',
          shapeProps: {
            width: 230,
            height: 110,
            x: -115,
            fill: '#fafafa',
            stroke: '#dadada',
            strokeWidth: 1,
            rx: '12px',
            ry: '12px',
            backgroundColor: 'black'
          }
        }}
        orientation="vertical"
        pathFunc="step"
        collapsible={false}
        translate={{
          x: 500,
          y: 30
        }}
        separation={{
          siblings: 2,
          nonSiblings: 2
        }}
        styles={{
          links: {
            stroke: '#b9b9b9'
          }
        }}
        transitionDuration={0}
        allowForeignObjects={true}
        nodeLabelComponent={{
          render: <NodeTree />,
          foreignObjectWrapper: {
            x: -115,
            height: 130,
            width: 240
          }
        }}
      />
    </div>
  );
};

export default DialogTreeComponent;
